/**
 * Canonical locale registry — single source of truth for all supported locales
 * (架构红线 #9：一处派生，加语言只改此文件).
 *
 * To add a new locale:
 *   1. Create the locale JSON in ./locales/<code>.json
 *   2. Import its messages + add one LOCALE_REGISTRY entry (nativeName + dateLocale)
 *
 * Everything else — SUPPORTED_LANGUAGE_CODES / LANGUAGES / i18n resources /
 * date-locale lookup — is derived automatically. No other file changes.
 *
 * `dateLocale` is a BCP-47 tag fed straight to the platform-native
 * `Intl.DateTimeFormat` / `toLocaleString`. We deliberately do NOT pull in
 * date-fns (架构红线 #1 SDK/native-first, #2 依赖方向): a string tag keeps the
 * registry dependency-free and usable from every layer.
 */
// `with { type: "json" }` import attribute is REQUIRED for raw Node ESM consumers
// (enterprise / admin-portal-api / feishu-bot / agent-host backends import this via
// the @dosia/shared barrel and run the tsc dist directly, not through a bundler).
// Node ≥20.10 rejects a bare JSON import with ERR_IMPORT_ASSERTION_TYPE_MISSING —
// crash-looped dosia-admin-portal-api on the v0.3.24 deploy. Bundlers (Vite/desktop)
// handle the attribute transparently. Do NOT remove.
import zhHansMessages from "./locales/zh-Hans.json" with { type: "json" };
import enMessages from "./locales/en.json" with { type: "json" };
import esMessages from "./locales/es.json" with { type: "json" };
import jaMessages from "./locales/ja.json" with { type: "json" };
import huMessages from "./locales/hu.json" with { type: "json" };
import deMessages from "./locales/de.json" with { type: "json" };
import plMessages from "./locales/pl.json" with { type: "json" };
/**
 * zh-Hans is the BASE locale (现有中文即真相源). It is listed first so the
 * language picker leads with it; `fallbackLng` in setupI18n also points here.
 *
 * Explicit Record annotation (not `satisfies` + inferred JSON literals):
 * 3750+ keys × 7 locales exceeds TS7056 .d.ts serialization if the catalog
 * type is inlined into the exported const.
 */
export const LOCALE_REGISTRY = {
    "zh-Hans": {
        nativeName: "简体中文",
        messages: zhHansMessages,
        dateLocale: "zh-CN",
    },
    en: { nativeName: "English", messages: enMessages, dateLocale: "en-US" },
    es: { nativeName: "Español", messages: esMessages, dateLocale: "es" },
    ja: { nativeName: "日本語", messages: jaMessages, dateLocale: "ja" },
    hu: { nativeName: "Magyar", messages: huMessages, dateLocale: "hu" },
    de: { nativeName: "Deutsch", messages: deMessages, dateLocale: "de" },
    pl: { nativeName: "Polski", messages: plMessages, dateLocale: "pl" },
};
//# sourceMappingURL=registry.js.map